import { useEffect, useState } from "react";

export const useScrollEffects = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Sticky Navbar
      if (window.pageYOffset >= 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }

      // Show or hide back-to-top button
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    const element = document.documentElement;
    const start = element.scrollTop;
    const change = 0 - start;
    const duration = 500;
    const increment = 20;
    let currentTime = 0;

    const easeInOutQuad = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    const animateScroll = () => {
      currentTime += increment;
      const val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;

      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };

    animateScroll();
  };

  return { isSticky, showBackToTop, scrollToTop };
};
